import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { sliceToDivisible } from '../../SidebarBlock/layouts/helpers';
import s from './SidebarGrid.scss';
const itemsPerRow = 3;
const SidebarGrid = ({ items, renderItem, maxRows = 3, className })=>{
    const isMobile = useContext(MobileContext);
    const responsive_fylt_grid = useFlag('responsive_fylt_grid');
    const maxItems = itemsPerRow * maxRows;
    const slice = sliceToDivisible(items, itemsPerRow, maxItems);
    let thumbHeight, thumbWidth;
    if (isMobile && responsive_fylt_grid) {
        thumbHeight = parseInt(s['sidebar-thumb-height-responsive']);
        thumbWidth = parseInt(s['sidebar-thumb-width-responsive']);
    } else {
        thumbHeight = parseInt(s['sidebar-thumb-height']);
        thumbWidth = parseInt(s['sidebar-thumb-width']);
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, slice.map((item, index)=>/*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
            key: index,
            value: {
                _rankIndex: index
            }
        }, renderItem({
            item,
            width: thumbWidth,
            height: thumbHeight,
            className: s['grid-item']
        }))));
};
SidebarGrid.displayName = 'SidebarGrid';
export default SidebarGrid;
